"use client";
import React from "react";
import Registration from "@packages/shared-components/user-profile/signin-signup/registration";

const Registrations = () => <Registration />;

export default Registrations;
